(function () {
  'use strict';

  const cfg = window.optisConditionalConfig || {};
  const triggerLabel = cfg.triggerLabel || 'Bestand uploaden';
  const triggerKeyword = (cfg.triggerKeyword || 'direct').toLowerCase();
  const targetLabel = cfg.targetLabel || 'Logo';

  let observer = null;

  function findStackByLabel(labelText) {
    const stacks = document.querySelectorAll('.po-stack');
    for (let i = 0; i < stacks.length; i++) {
      const labelEl = stacks[i].querySelector('.po-label-container .po-label > span, .po-label-container .po-label');
      if (!labelEl) continue;
      if ((labelEl.textContent || '').trim() === labelText) return stacks[i];
    }
    return null;
  }

  function applyConditional() {
    const triggerStack = findStackByLabel(triggerLabel);
    const targetStack = findStackByLabel(targetLabel);
    if (!triggerStack || !targetStack) return false;

    const checked = triggerStack.querySelector('input[type="radio"]:checked');
    let shouldShow = false;
    if (checked) {
      const val = (checked.value || '').toLowerCase();
      shouldShow = val.indexOf(triggerKeyword) !== -1;
    }

    if (shouldShow) {
      if (targetStack.style.display === 'none') targetStack.style.display = '';
      targetStack.removeAttribute('data-optis-hidden');
    } else {
      if (targetStack.style.display !== 'none') targetStack.style.display = 'none';
      targetStack.setAttribute('data-optis-hidden', 'true');
    }
    return true;
  }

  function setupObserver() {
    if (observer) return;
    const root = document.querySelector('.bss-po-option-set') || document.body;
    observer = new MutationObserver(function () {
      applyConditional();
    });
    observer.observe(root, { childList: true, subtree: true });
  }

  function init() {
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('.po-stack input[type="radio"]')) {
        applyConditional();
      }
    });

    if (applyConditional()) {
      setupObserver();
      return;
    }
    let tries = 0;
    const interval = setInterval(function () {
      tries++;
      if (applyConditional()) {
        setupObserver();
        clearInterval(interval);
      } else if (tries > 60) {
        clearInterval(interval);
      }
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
